import React from 'react'
import { useNavigate } from 'react-router-dom'
import { connect } from 'react-redux'
import './auth.css'
import { useContext } from 'react'
import { NavbarContext } from '../../Context/NavbarContext'

const LoginSuccess = ({ user }) => {
  const navigate = useNavigate()
  const {setCurrentPath} = useContext(NavbarContext)
  return (
    <div className='container container_light auth'>
      <div className='logo'>
        <img src='/assets/images/logo.png' alt='' />
        <h3>RROWHEAD</h3>
      </div>
      <div className='content'>
        <h1>
          🪄
          <br />
          Hi {`${user?.data?.name.split(' ')[0][0].toUpperCase()}${user?.data?.name.split(' ')[0].slice(1).toLowerCase()}`},
          <br />
          You’re all set!
        </h1>
        <p>Join your next meeting to see the magic!</p>
        <button
          className='login-success-button'
          onClick={() => {
            setCurrentPath(['transcripts-summaries']) 
            navigate('/transcripts-summaries')
          }}
        >
          Let&apos;s go!
        </button>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  user: state.user,
})

export default connect(mapStateToProps, null)(LoginSuccess)
